<template>
  <div
    class="d-flex align-items-center">
    <svg-circle-icon
      v-if="complete"
      variant="primary"
      :height="32"
      :width="32"
      :stroke-width="3">
      <svg-check/>
    </svg-circle-icon>
    <div
      v-else
      class="empty-circle"/>
    <span
      v-if="$slots.detail"
      class="ms-xs">
      <slot name="detail"/>
    </span>
  </div>
</template>

<script>
import SvgCircleIcon from '@/components/global/svg/SvgCircleIcon.vue'
import SvgCheck from '@/components/global/svg/SvgCheck.vue'

export default {
  name: 'ReferralProgressCheck',
  components: {
    SvgCircleIcon,
    SvgCheck
  },
  props: {
    complete: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .empty-circle {
    border: 2px solid $ash;
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
</style>
